// QA-mode unlock for not-yet-released sections (e.g. Promotions).
//
// Unreleased sections are normally hidden outside dev (see isDevEnvironment).
// QA needs to see them on deployed environments without a special build, so:
//
//   1. The deploy pipeline bakes a secret into the build as REACT_APP_QA_KEY.
//      Builds without the env var can never be unlocked (this returns false).
//   2. A QA tester visits any page with `?qa=<key>` once; the unlock persists
//      in localStorage for that browser. `?qa=off` turns it back off.
//
// SCOPE: this only reveals hidden sections. It must NEVER feed the dev-only
// bsm.* permission bypass — real permissions still apply in QA mode.
const STORAGE_KEY = "wwg.store.qaMode";

export default function isQaModeEnabled() {
  const key = process.env.REACT_APP_QA_KEY;
  if (!key) return false;
  try {
    const supplied = new URLSearchParams(window.location.search).get("qa");
    if (supplied === "off") {
      window.localStorage.removeItem(STORAGE_KEY);
    } else if (supplied === key) {
      window.localStorage.setItem(STORAGE_KEY, key);
    }
    // Stored value must match the CURRENT key, so rotating the secret in the
    // pipeline instantly revokes every previously unlocked browser.
    return window.localStorage.getItem(STORAGE_KEY) === key;
  } catch (err) {
    return false;
  }
}
